export default __webpack_public_path__ + "static/media/grandma4M.c2dc4048.jpg";